<template>
    <a
        href="/wishlist"
        :class="
            isMobile 
                ? 'hdr-shortcutLink mr-7 pl-5 py-2 border-l-[5px] border-transparent text-base'
                : 'hdr-shortcutLink mr-7' 
        "
    >
        <template v-if="isMobile">WISHLIST</template>
        <template v-else>
            <!-- <img
                src="/assets/icon/ic-star.svg"
                alt="star-icon"
                width="20"
                height="20"
                class="object-contain block"
            > -->
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1201_16431)">
                    <path d="M4.07482 19.1513L4.07525 19.1514L5.11275 13.2389L5.15903 12.9751L4.96514 12.7904L0.561732 8.59576C0.561694 8.59573 0.561656 8.59569 0.561618 8.59565C0.507331 8.54376 0.487974 8.46781 0.511647 8.38834C0.535103 8.3096 0.585387 8.27276 0.63988 8.2651L0.640613 8.26499L6.76311 7.39499L7.02156 7.35827L7.13916 7.12522L9.86916 1.71522L9.86929 1.71529L9.87453 1.70425C9.88598 1.6801 9.90405 1.65969 9.92664 1.64541C9.94923 1.63112 9.97542 1.62354 10.0021 1.62354C10.0289 1.62354 10.0551 1.63112 10.0776 1.64541C10.1002 1.6597 10.1183 1.6801 10.1298 1.70425L10.1296 1.70431L10.1352 1.71526L12.8652 7.12401L12.9828 7.35702L13.2412 7.39374L19.3637 8.26374L19.3646 8.26387C19.4199 8.27163 19.4697 8.30861 19.4928 8.38651C19.5162 8.46535 19.497 8.54153 19.4419 8.59399L19.4416 8.59423L15.0391 12.7892L14.8453 12.9739L14.8915 13.2376L15.929 19.1501L15.9291 19.1504C15.9444 19.2374 15.9107 19.3038 15.8621 19.3424C15.8154 19.3795 15.7673 19.3844 15.7176 19.359C15.7175 19.359 15.7174 19.3589 15.7172 19.3588L10.2313 16.539L10.0028 16.4215L9.77423 16.539L4.28707 19.3588C4.28697 19.3589 4.28688 19.3589 4.28679 19.359C4.23709 19.3844 4.18906 19.3795 4.14241 19.3424C4.09429 19.3042 4.06037 19.2382 4.07482 19.1513ZM9.94254 16.0484L9.9424 16.0479C9.96051 16.0386 9.98056 16.0338 10.0009 16.0338C10.0214 16.0338 10.0416 16.0387 10.0599 16.0481L10.0605 16.0484L14.668 18.4159L15.5628 18.8757L15.389 17.8848L14.5215 12.9386L14.5211 12.9364C14.5151 12.903 14.5174 12.8688 14.5278 12.8366C14.538 12.8048 14.5558 12.776 14.5796 12.7526C14.5799 12.7523 14.5803 12.752 14.5806 12.7516L18.2103 9.29189L18.9572 8.57991L17.9355 8.43492L12.8749 7.71682C12.8744 7.71675 12.874 7.71667 12.8735 7.71659C12.849 7.71267 12.8259 7.70299 12.8059 7.68835C12.7855 7.67343 12.7691 7.65378 12.758 7.63111L12.758 7.63109L12.7554 7.62585L10.4466 3.05335L10 2.16891L9.55384 3.05355L7.24759 7.62605L7.24756 7.62603L7.24508 7.63111C7.23396 7.65378 7.21751 7.67343 7.19714 7.68835C7.17715 7.703 7.15397 7.71268 7.12952 7.7166L2.0674 8.43619L1.04608 8.58137L1.79279 9.29314L5.42335 12.7538C5.44708 12.7771 5.46481 12.8058 5.47504 12.8375C5.48541 12.8697 5.48773 12.9039 5.4818 12.9371L5.48154 12.9386L4.61404 17.8848L4.44025 18.8757L5.33504 18.4159L9.94254 16.0484Z" fill="#828282" stroke="#A9B5C6"/>
                </g>
                <defs>
                    <clipPath id="clip0_1201_16431">
                        <rect width="20" height="20" fill="white" transform="translate(0 0.5)"/>
                    </clipPath>
                </defs>
            </svg>
        </template>
    </a>
</template>
<script>

import { computed, defineComponent, watch } from "@vue/runtime-core";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import useWishlist from "@/composables/useWishlist";

export default defineComponent({
    name: 'WishlistHeaderIcon',
    props:{
        isMobile:{
            type:Boolean,
            default:false
        }
    },
    setup() {
        
        const store = useStore();
        const router = useRouter();

        const { fetchWishlist } = useWishlist();
        const fetchWishlistUrl = computed(() => store.state.api.routes.wishlistFetch);

        watch(
            () => (
                typeof fetchWishlistUrl.value === 'string' && 
                store.state.user.token && 
                router.currentRoute.value.name == 'wishlist'
            ),
            (bool) => {
                if(bool) fetchWishlist();
            },
            { immediate: true }
        );
    },
});
</script>